import { AssessmentSectionBlock } from '@ketch-com/windlass/dist/assessments/assessments'
import { ConditionMap } from '../context/AssessmentConditionalRenderContext'

export type AssessmentRenderBlocks = (AssessmentSectionBlock | AssessmentSectionBlock[])[]

/**
 * Filters and Merges conditional and non-conditional assessment blocks according to rendering conditions
 */
export function mergeConditionalBlocks(
  blocks: AssessmentSectionBlock[],
  renderConditionsMap: ConditionMap,
): AssessmentRenderBlocks {
  const blocksToRender: AssessmentRenderBlocks = []
  let conditionalAccordianBlocks: AssessmentSectionBlock[] = []
  blocks.forEach(block => {
    if (block.isRenderOnCondition) {
      if (block.conditionId && renderConditionsMap[block.conditionId]?.conditionMet) {
        conditionalAccordianBlocks.push(block)
      }
    } else {
      if (conditionalAccordianBlocks.length) {
        blocksToRender.push(conditionalAccordianBlocks)
        conditionalAccordianBlocks = []
      }
      blocksToRender.push(block)
      if (conditionalAccordianBlocks.length) {
        blocksToRender.push(conditionalAccordianBlocks)
        conditionalAccordianBlocks = []
      }
    }
  })

  if (conditionalAccordianBlocks.length) {
    blocksToRender.push(conditionalAccordianBlocks)
  }

  return blocksToRender
}
